export default "__VITE_ASSET__DZBWokzl__"